export enum UserAccess {
    None = 0,
    ZPocket = 1,
    ZFreedom = 2,
}

export function getAccessFromEnum(access: UserAccess): UserAccess[] {
    return Object.entries(UserAccess)
        .filter(([key, value]) => typeof value === "number" && access & value)
        .map(([key, val]) => UserAccess[key as keyof typeof UserAccess]);
}